<mat-card class="slidecontent">
    <div class="headcontent">
      <div class="pophead">
        <h3>Apply Filter</h3>
        <button mat-icon-button (click)="clearAllClick()">
          <mat-icon class="close" >close</mat-icon>
        </button>
      </div>
  
    </div>
    <div class="dialog_content" [formGroup]="myFormGroup">        
      <mat-form-field appearance="">
        <mat-label>Form Type</mat-label>
        <mat-select formControlName="FileType" (selectionChange)="fileTypeSelection($event)"  required>
          <mat-option *ngFor="let fileType of fileTypes" [value]="fileType.value">{{ fileType.name }}</mat-option>
        </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="">
        <mat-label>By Date</mat-label>
        <mat-select  formControlName="FilterColType" (selectionChange)="dateTypeSelection($event)" >
          <mat-option value="Cr">Date Created</mat-option> 
          <mat-option value="Mod">Date Modified</mat-option>
        </mat-select>
      </mat-form-field> 
     
      <mat-form-field class="example-full-width">
        <mat-label>Select Date Range</mat-label>      
        <input matInput ngxDaterangepickerMd formControlName="dateRange" 
         placeholder="Select Date Range" [showCustomRangeLabel]="true"
         [alwaysShowCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCancel]="true"
         [linkedCalendars]="false" [locale]="{ applyLabel: 'Done' }" [keepCalendarOpeningWithRange]="true"
         [showRangeLabelOnInput]="false" (rangeClicked)="rangeClicked($event)"
         (datesUpdated)="datesUpdated($event)" >
      </mat-form-field>
    </div>
  
  
    <div class="actionBtn">  
      <button mat-flat-button class="calltoaction" type="submit" color="basic" (click)="clearAllClick()"> Clear All </button>  
      <button mat-flat-button class="calltoaction" type="submit" [disabled]=!showApplyButton color="primary" (click)="closeFilterSilde(true)">Apply</button>
    </div>
  
  
  </mat-card>

  <div class="overlay" (click)="closeFilterSilde(false)"></div>
